import { graphql, SliceComponentProps } from "gatsby";
import React from "react";
import { AdditionalNavBarProps, NavBarSliceContext } from "./types";
import { DefaultNavBarQuery } from "types/graphql-types";
import SliceProviders from "./SliceProviders";
import { isPresent } from "src/utils/checks";
import MegaMenu from "components/HeaderNavBar/MegaMenu/MegaMenu";

const DefaultNavBar: React.FC<
  SliceComponentProps<
    DefaultNavBarQuery,
    NavBarSliceContext,
    AdditionalNavBarProps
  >
> = ({ data, sliceContext, alternateLinks, hideBookCTA, transparentMenu }) => {
  const searchUrl = data.globalSearchPagePath;
  const fycUrl = hideBookCTA === true ? undefined : data.fycPagePath;
  const allLinks = data.mainMenu;

  return (
    <SliceProviders languageCode={sliceContext.languageCode}>
      <MegaMenu
        fycUrl={fycUrl}
        data={allLinks}
        destinations={data.destinations.nodes || []}
        ships={data.ships.nodes || []}
        promos={data.promos.nodes || []}
        topLinks={data.topMenu?.items?.filter(isPresent) || []}
        alternateLinks={alternateLinks}
        searchUrl={searchUrl}
        menuPrimaryCTA={data.mainMenu?.menuPrimaryCTA}
        cruisesLaunches={data.cruisesLaunches.nodes || []}
        variant="normal"
        isTransparent={transparentMenu}
      />
    </SliceProviders>
  );
};

// eslint-disable-next-line import/no-unused-modules
export const query = graphql`
  query DefaultNavBar($today: Date, $menuSource: [String]) {
    globalSearchPagePath

    mainMenu: sanityMainMenu(_id: { in: $menuSource }) {
      mainMenu {
        ...MainMenuSection
      }
      menuPrimaryCTA {
        ...CustomMenuItem
      }
    }

    topMenu: sanityTopMenu(_id: { in: ["top-menu", "drafts.top-menu"] }) {
      items {
        ...TopMenuItem
      }
    }

    ships: allSanityShip(
      sort: { name: ASC }
      filter: { isVisible: { eq: true } }
    ) {
      nodes {
        _id
        name
        fullPath
        card {
          image {
            ...ImageWithAlt
          }
        }
        shipType
        versions {
          validFrom
          crewCount
          passengerCount
        }

        metadata {
          tracking {
            name
          }
        }
      }
    }
    fycPagePath
    destinations: allSanityDestination {
      nodes {
        _id
        fullPath
        destinationWebCode
        name {
          localized
        }
        card {
          image {
            ...ImageWithAlt
          }
        }
        metadata {
          tracking {
            name
          }
        }
      }
    }
    promos: allSanityExclusiveOfferPerPromo(
      filter: { configuration: { code: { ne: null } } }
    ) {
      nodes {
        _id
        hideInMainMenu
        fullPath
        title {
          localized
        }
        fycFilterDescription {
          localized
        }
        iconVertical {
          asset {
            url
          }
        }
        cardWithIcon {
          icon
        }
        configuration {
          code
        }
        metadata {
          tracking {
            name
          }
        }
      }
    }
    cruisesLaunches: allSanityCruisesLaunch(
      sort: { validFrom: ASC }
      filter: { validFrom: { lte: $today } }
    ) {
      nodes {
        ...MenuItemCruisesLaunch
      }
    }
  }
`;

export default DefaultNavBar;
